var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "gfu-project-summary-clock",
      attrs: { "data-qa": "countdown-clock" },
    },
    [
      _c("div", { staticClass: "gfu-project-summary-clock__head" }, [
        _c(
          "strong",
          { staticClass: "gfu-project-summary-clock__title gfu-hd gfu-hd--h5" },
          [_vm._v(_vm._s(_vm.title))]
        ),
      ]),
      _vm._v(" "),
      _c("countdown-clock", {
        staticClass: "_mx-a",
        attrs: {
          timestamp: _vm.targetDate,
          "elapsed-message": _vm.elapsedMessage,
          "pad-numbers": "",
          "data-qa": "countdown-clock",
        },
      }),
      _vm._v(" "),
      _vm.isEndgameTextVisible
        ? _c(
            "div",
            { attrs: { "data-qa": "project-overtime-text" } },
            [
              _c("base-divider", { staticClass: "_my-0" }),
              _vm._v(" "),
              _c(
                "h4",
                { staticClass: "gfu-hd gfu-hd--h4 _tac _py-1 gfu-bt--caption" },
                [
                  _c("span", { staticClass: "_tc--error" }, [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.endgameText) +
                        "\n            "
                    ),
                  ]),
                ]
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }